import { Controller } from "@hotwired/stimulus"
import { TurboConfirm } from "@rolemodel/turbo-confirm"

export default class extends Controller {
  static targets = ['select', 'selectAll']

  async export(e) {
    e.preventDefault()

    const url = e.target.dataset.exportUrl || this.element.dataset.exportUrl
    this.triggerDownload(this.selectionUrl(url))
  }

  async factoringExport(e) {
    e.preventDefault()

    const { exportUrl, checkUrl, confirmButton } = e.currentTarget.dataset
    const response = await fetch(this.selectionUrl(checkUrl), { headers: { Accept: 'application/json' } })
    if (!response.ok) return

    const { message } = await response.json()
    if (message) {
      const confirmed = await new TurboConfirm().confirmWithContent({
        '#confirm-title': message,
        '#confirm-accept': confirmButton
      })
      if (!confirmed) return
    }

    this.triggerDownload(this.selectionUrl(exportUrl))
  }

  // Select-all exports everything matching the current filters, otherwise only the checked rows
  selectionUrl(url) {
    const query = this.selectAllTarget.checked
      ? new URLSearchParams(window.location.search).toString()
      : this.getSelectedIds().map(id => `ids[]=${id}`).join('&')

    if (!query) return url

    return `${url}${url.includes('?') ? '&' : '?'}${query}`
  }

  triggerDownload(url) {
    const filename = this.element.dataset.exportName || 'export.csv'
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  getSelectedIds() {
    return this.selectTargets.filter(select => select.checked).map(select => select.value)
  }
}
